import { render, staticRenderFns } from "./week_overview.vue?vue&type=template&id=c2368fe4&scoped=true"
import script from "./week_overview.vue?vue&type=script&lang=js"
export * from "./week_overview.vue?vue&type=script&lang=js"
import style0 from "./week_overview.vue?vue&type=style&index=0&id=c2368fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2368fe4",
  null
  
)

export default component.exports